import { render, staticRenderFns } from "./SilageTableMobile.vue?vue&type=template&id=4b57b012&scoped=true&lang=pug"
import script from "./SilageTableMobile.vue?vue&type=script&lang=js"
export * from "./SilageTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b57b012",
  null
  
)

export default component.exports